<template>
    <div class="">
        <div class="header-panel">
        <Breadcrumb 
            :levelTwoText = "'Routes'"
            :levelTwoLink = "'/routes'"
            :levelThreeText = "route_name"
        
        />

        <Heading 
            :preheading = "(this.metadata && this.metadata.bikepacking ? 'Bikepacking' : 'Bike Touring') + ($noThe(route_name) ? '' : ' The')"
            :heading = "route_name"
            
            :level="1"
            :anchor="'blogs'"
            :noSpaceBelow = "false"
            :long = "route_name.length > 25 ? true : false"
        />
         <TOC 
            :slot1text="'Blogs'"
            :slot1link="'blogs'"
            :slot2text="'Books'"
            :slot2link="'books'"
            
            />
        
        <div class="spacer" style="height:20px"></div>
        </div>
        <div class="container">
        <div class="spacer" style="height:30px"></div>
        <Heading 
                    :heading = "'Blog Posts' + (this.postCount && this.postCount > 1 ? ' (' + this.postCount + ')' : '')"
                
                    :anchor = "'blogs'"
                    :smaller="true"
                />
            
        <div class="columns is-multiline is-variable is-4-desktop">
            <PageResultColumns  
                v-for="(page, idx) in this.resultPages"
                v-bind:key = idx 
                :page = "page"
                :approveMode = "false"
                :showYear="true"
            />
        </div>
        
    <div class="section card" ref="results" v-if="isLoading">
        <b-icon class="fas fa-spinner fa-spin"></b-icon>
        Loading...
    </div>
    <div class="section card" ref="results" v-if="!isLoading && resultPages.length == 0">
        <!-- <b-icon class="fas fa-spinner fa-spin"></b-icon> -->
        None yet :(  You can <a href="/add">submit a blog post</a> to start filling this section.
    </div>
    
    <div class="spacer" style="height:60px"></div>

    <b-button type="is-primary is-large" style="margin-bottom:10px" v-if="!noMorePages && resultPages.length > 0" @click="nextPage" v-scroll-to="{
            el:'#result-last',
            easing:'ease',
            offset: -100
        
    }">Load more</b-button>
    <!-- <div v-if="activeFilterCount > 0" style="padding: 30px 0px; font-size: 18px; text-align:left">To see more results, <a v-on:click="clearFilters">click here to clear filters</a></div> -->
    <b-button v-if="resultPages.length > 0" v-scroll-to="'#app'" class="is-large">Scroll to top</b-button>


    <div class="books" ref="books">
        <div class="spacer" style="height:80px"></div>
        <div class="divider"></div>
        <div class="spacer" style="height:60px"></div>

       

        <BooksList v-if="!isLoading" 
            :anchor="'books'"
            
            :heading = "'Books'"
            :subheading = "'About ' + ($noThe(route_name) ? '' : 'The ') + $titleCase(route_name)"
            :property = "'routes'"
            :operator = "'array-contains'"
            :value = "route_name"

            :headingFallback = "'Books'"
            :subheadingFallback = "'About ' + getStyle()"
            :propertyFallback = "(this.metadata && this.metadata.bikepacking) ? 'bikepacking' : 'touring'"
            :operatorFallback = "'=='"
            :valueFallback = "true"

            :num = "8"
            :isMinimal = "true"
        />


        <!-- <div class="columns is-multiline is-variable is-3-desktop" v-if="!isLoading">
        <Book  
            v-for="book in booksByRoute"
            v-bind:key = book.id
            :bookObj="book"
            />
        </div>
        <router-link to="/books/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all books</router-link>
        <div class="spacer" style="height:30px"></div>
        <p class="is-size-7 is-size-7-mobile">Some book links are affiliate links, which means BikeSleepBike may earn a small commission at no extra cost to you if you buy something through them.
                The money helps pay for hosting and infrastructure costs of running this website. As an Amazon Associate I earn from qualifying purchases. Thanks!

            </p> -->
    </div>
    <!-- <b-modal v-model="isModalActive">
                <div>HI</div>
            </b-modal> -->
    <div class="spacer" style="height:100px"></div>
    <Intro v-if="metadata"
            :metadata="metadata"
        />


    <!-- REPLACE LATER WITH NEARBY ROUTES? -->
    <!-- <div class="popular-routes" v-if="routesByCountry.length > 0">
        <div class="spacer" style="height:80px"></div>
        <div class="divider"></div>
        <div class="spacer" style="height:80px"></div>

        <Heading 
            :heading = "'Routes in ' + country_name"
        />
        

        <div v-if="routesByCountry.length > 0">
            <ul >
                <li  class="list-link" v-for="routeObj in routesByCountry" v-bind:key="routeObj.display_name" >
                    <RouteRow  v-if="(routesByCountry.length >= 3 && routeObj.countries.length <= 2 && routeObj.post_count >= 3 || routesByCountry.length < 5)"
                        v-bind:routeObj = "routeObj"
                    />
                </li>
            </ul>
        </div>
        <a href="/routes/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all routes</a>
        
    </div> -->
    <div class="spacer" style="height:100px"></div>
    </div>
    </div>
</template>

<script>
import PageResultColumns from '@/components/PageResultColumns';
// import PageResult from '@/components/PageResult';
// import ContinentFilter from '@/components/ContinentFilter';
import Heading from '@/components/Heading';
import RouteRow from '@/components/RouteRow';
import Intro from '@/components/Intro';
import Breadcrumb from '@/components/Breadcrumb';
import Book from '@/components/Book';
import BooksList from '@/components/BooksList';
import TOC from '@/components/TOC';

export default {
  name: 'Route',
  components: {PageResultColumns, Heading, RouteRow, Intro, Breadcrumb, Book, BooksList, TOC},
  
  props: ['route', 'post_count'],
  data () {
    return {
        // isModalActive: true,
        route_name: this.$unkeyify(this.route),
        metadata: "",
        isLoading: false,
        noMorePages: false,
        lastVisibleResult: undefined,
        currentQuery: undefined,
        queryLimit: 21,
        resultPages: [],
        // booksByRoute: [],
        postCount: '',
        booksShown: false
       
    }
  },
  watch: {
      "$route.params.route"(newroute) {
        this.route_name = this.$unkeyify(newroute);
        this.fetchPages("routes", "array-contains", this.route_name);
        console.log("Vue router route changed ");
        this.$fetchDoc("routes", this.$keyify(this.route_name), 'metadata'); 
        // console.log(route_name);
        // console.log(this.$keyify(this.route_name));
        // this.fetchBooksByRoute(this.route_name);
        },
  },
  methods: {
      getStyle() {
        if (this.metadata) {
            if (this.metadata.touring) {
                return "Bicycle Touring"
            } else if (this.metadata.bikepacking ) {
                return "Bikepacking";
            }  else {
                return "Bike Travel";
            }
        }   else {
            return 'Bike Travel';
        }

      },
      getSubtitle() {
          if (this.metadata) {
              if (this.metadata.racing) {
                  return "Bikepacking Blog Directory"
              } else if (this.metadata.bikepacking ) {
                  return "Bikepacking Blog Directory";
              } else {
                  return "Bike Touring Blog Directory";
              }
          } else {
              return "Bike Touring Blog Directory";
          }
      },
      getCount(route) {
        var that = this;
        this.$db.collection("page_counts").doc('routes').get()
        .then(function(doc) {
            
            if (doc.exists) {
                // console.log(doc.data()[route]['post_count'].toString());
                // console.log(doc.data());
                that.postCount = doc.data()[route]['post_count'].toString();
            } else {
                console.log("ERROR: Can't fetch route post count", route);
                that.postCount = '';
            }

        })
        .catch(function(error) {
            console.log("Error Can't fetch route post count ", error);
            that.postCount = '';
        });
        // }
            
      },
    
      fetchPages(fieldname, querytype, value) {
            if (this.$debug) {console.log("DEBUG: In function fetchPages");}
            
            if (value != "") { // GET FILTERED
                this.$analytics.logEvent('fetch_results', { type: 'style', value: value});
                this.isLoading = true;
                var that = this;
                var result = [];
                this.noMorePages = false;
                this.lastVisibleResult = undefined;
                this.currentQuery = this.$db.collection("pages").where(fieldname, querytype, value).orderBy("year", "desc").orderBy("added", "desc");
                this.currentQuery.limit(that.queryLimit).get()
                    .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            var dataAndId = doc.data();
                            dataAndId['id'] = doc.id;
                            result.push(dataAndId);
                        
                        });
                        that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                        if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                            that.noMorePages = true;
                        }
                        that.resultPages = result;
                        that.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log("Error getting pages by style: ", error);
                        that.isLoading = false;
                    });
            } 
        },

        
        nextPage() {
            if (this.$debug) {console.log("DEBUG: In function nextPage");}
            var that = this;
            var result = [];  
            // var queryLimit = this.pageSize;
            //     if (this.activeFilterCount > 0) { //override pagination if filters are being used (hack for now because firebase sucks at tag filtering)
            //         queryLimit = 1000;
            //     }
            if (this.lastVisibleResult) {
                this.noMorePages = false;
                this.currentQuery.startAfter(this.lastVisibleResult).limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        // result.push(doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    // console.log("last");
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages.push(...result);
                    // that.resultPages = [].concat(that.resultPages, result); // this is for loading more below
                    // that.resultPages = result; // this is for replacing results with next page
                    // that.showingSelected = false;
                    // console.log(that.$route.path);
                    // if (that.$route.path != '/d') {
                    //     that.$router.push({ path: '/d'});
                    // }
                })
                .catch(function(error) {
                    console.log("Error getting next chunk of page results: ", error);
                });         

            } else {
                this.noMorePages = true;
            }
                  
           
        },
        // fetchBooksByRoute(route) {
        //     if (this.$debug) {console.log("DEBUG: In function fetchPagesByRoute");}
        
        // // if (value != "") { // GET FILTERED
        //     this.$analytics.logEvent('fetch_results', { type: 'books by route', value: route});
        //     var that = this;
        //     var result = [];
           
        //     this.$db.collection("books").where('routes', 'array-contains', route).orderBy("title", "asc").limit(8).get()
        //         .then(function(querySnapshot) {
        //             querySnapshot.forEach(function(doc) {
        //                 // doc.data() is never undefined for query doc snapshots
        //                 var dataAndId = doc.data();
        //                 dataAndId['id'] = doc.id;
        //                 result.push(dataAndId);
                    
        //             });
                   
        //             that.booksByRoute = result;
        //             // that.isLoading = false;
        //         })
        //         .catch(function(error) {
        //             console.log("Error getting books by route: ", error);
        //             // that.isLoading = false;
        //         });
        // // } 
        // },
      
    

  },
  metaInfo() {
        var title =  this.route_name + " - " + this.getSubtitle();
        var description = "Blog posts and trip reports about " + (this.metadata && this.metadata.bikepacking ? 'bikepacking ' : 'bicycle touring ') + this.route_name;
        return {
            // title: title + (this.postCount ? ( " (" + this.postCount + ")" ) : '' ),

            title: title,
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },
  mounted() {
    // this.route_name = this.$route.params.route;
    // console.log("UNKEYIFYIED:", this.route_name);
    this.fetchPages("routes", "array-contains", this.route_name);
    // console.log("Getting ");
    this.$fetchDoc("routes", this.$keyify(this.route_name), 'metadata'); 

    // this.fetchBooksByRoute(this.route_name);
    this.getCount(this.route_name);
     
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  

</style>

<style>
    .page-results {
        max-width: 1500px;
        margin-left: auto;
        margin-right: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Route.vue